import * as React from 'react';

export const AppAuthenticationProviderContext = React.createContext(null);
